const IVA = 1.19

function discount() {
    console.log(
        'this is my first mehtod import exportid for using in caja vuex'
    )
}

function isExento(es_excento) {
    if (es_excento == null || es_excento == '0') {
        return 'no'
    } else {
        //excento
        return 'si'
    }
}

function getPrecioVenta(exento, valor) {
    if (exento == 'no') return Math.round(parseInt(valor) / IVA)
    else return parseInt(valor)
}

function getMontoFinalConDesctoGlobal(precioVenta, cantidad, descuento) {
    if (descuento > 0) {
        let auxMontoneto = precioVenta * cantidad
        return auxMontoneto - Math.round((auxMontoneto * descuento) / 100)
    } else {
        return precioVenta * cantidad
    }
}
function totalIvaFactura(desctoGlobal, cartProductsFactura) {
    let total = 0
    const iva = 0.19
    const descuentoGlobal = desctoGlobal

    cartProductsFactura.forEach(product => {
        if (product.es_excento == 'no') total += parseInt(product.monto_neto)
    })
    console.log(total, 'totalivaaFACTURA')
    if (descuentoGlobal > 0) {
        let result = total * iva
        return Math.round(result - (result * descuentoGlobal) / 100)
    } else {
        return Math.round(total * iva)
    }
}

function totalNetoFactura(desctoGlobal, cartProductsFactura) {
    let total = 0
    const descuentoGlobal = desctoGlobal

    cartProductsFactura.forEach(product => {
        if (product.es_excento == 'no') total += parseInt(product.monto_neto)
    })

    if (descuentoGlobal > 0) {
        let descuento = Math.round(total * (descuentoGlobal * 0.01))
        return total - descuento
    } else {
        return total
    }
}

function totalExentos(desctoGlobal, cartProductsFactura) {
    let total = 0
    const descuentoGlobal = desctoGlobal

    cartProductsFactura.forEach(product => {
        if (product.es_excento == 'si') total += parseInt(product.monto_neto)
    })

    if (descuentoGlobal > 0) {
        let descuento = Math.round(total * (descuentoGlobal * 0.01))
        return total - descuento
    } else {
        return total
    }
}

function percentage(percentage, totalValue) {
    return ((totalValue*percentage)/100)
 } 

export default {
    discount,
    isExento,
    getPrecioVenta,
    getMontoFinalConDesctoGlobal,
    totalIvaFactura,
    totalNetoFactura,
    totalExentos,
    percentage
}
